<template>
  <div class="invitation">
    <VTabs
      align-with-title
      fixed-tabs
      :value="`${currentType}`"
      height="56px"
      class="mb-8"
    >
      <VTab
        class="py-1"
        v-if="vacancy.visibility === vacancyVisibilities.ALL"
        :href="`#${invitationTypes.SHAREABLE}`"
        @click="changeInvitationType(invitationTypes.SHAREABLE)"
      >
        {{ $t('shareable') }}
      </VTab>
      <VTab
        class="py-1"
        :href="`#${invitationTypes.PERSONAL}`"
        @click="changeInvitationType(invitationTypes.PERSONAL)"
      >
        {{ $t('personal') }}
      </VTab>
      <VTab
        class="py-1"
        :href="`#${invitationTypes.EXCEL}`"
        @click="changeInvitationType(invitationTypes.EXCEL)"
      >
        {{ $t('excel') }}
      </VTab>
    </VTabs>
    <div>
      <ShareableLink
        :key="key"
        :vacancy="vacancy"
        v-if="currentType === invitationTypes.SHAREABLE"
      />
      <PersonalInvitation
        @cancel="$emit('cancel')"
        :key="key"
        :vacancy="vacancy"
        v-else-if="currentType === invitationTypes.PERSONAL"
      />
      <ImportFromExcel
        :key="key"
        :vacancy="vacancy"
        v-else-if="currentType === invitationTypes.EXCEL"
      />
    </div>
  </div>
</template>

<script>
import { candidateInvitationType, vacancyVisibility } from '@/enums';
import { computed, ref, toRefs } from '@vue/composition-api';
import ShareableLink from '@/components/CandidateInvitation/ShareableLink';
import PersonalInvitation from '@/components/CandidateInvitation/PersonalInvitation';

export default {
  name: 'CandidateInvitation',
  components: { ImportFromExcel: () => import('@/components/CandidateInvitation/ImportFromExcel'), PersonalInvitation, ShareableLink },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const invitationTypes = ref(candidateInvitationType);
    const vacancyVisibilities = ref(vacancyVisibility);
    const { vacancy } = toRefs(props);

    const visibilityInvitation = [
      candidateInvitationType.EXCEL,
      candidateInvitationType.PERSONAL,
    ];

    let currentType;

    if (vacancy.value.visibility === vacancyVisibility.INVITATION) {
      const storageType = visibilityInvitation.includes(localStorage.getItem('chosenInvitationType'))
        ? localStorage.getItem('chosenInvitationType')
        : null;

      currentType = ref(storageType || candidateInvitationType.PERSONAL);
    } else {
      currentType = ref(localStorage.getItem('chosenInvitationType') || candidateInvitationType.SHAREABLE);
    }

    function changeInvitationType(invitationType) {
      if (currentType.value !== invitationType) {
        localStorage.setItem('chosenInvitationType', invitationType);
        currentType.value = invitationType;
      }
    }

    const key = computed(() => Date.now());

    return {
      currentType,
      changeInvitationType,
      invitationTypes,
      key,
      vacancyVisibilities,
    };
  },
};
</script>

<style lang="scss" scoped>
.invitation {
  .v-tab.v-tab--active::after {
    height: 2px;
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .invitation {
    padding: 0 1.75rem 0;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .invitation {
    padding: 0 1rem 1.25rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
shareable: Shareable link
personal: Personal invitation
excel: Import from Excel
</i18n>

<i18n locale="ru" lang="yaml">
shareable: Поделиться ссылкой
personal: Персональное приглашение
excel: Импорт из Excel
</i18n>
